module.exports = __webpack_public_path__ + "static/media/map-pin.8e3ad8b8.svg";